// extracted by mini-css-extract-plugin
export default {"form":"Section_form__QMCGA","modal":"Section_modal__Xj8Fd"};